// MuiCard-root
import { lightPalette } from "../palette";

export const MuiCard = {
  MuiCard: {
    styleOverrides: {
      root: {
        "&.MuiPaper-root": {
          // border: "none !important",
        },
        backgroundColor: lightPalette.background.paper,
        color: lightPalette.text.secondary,
        "&:hover": {
          borderColor: lightPalette.primary.main,
        },
      },
    },
  },
};
